module.exports = __webpack_public_path__ + "static/inviteless3.2f718bc2.png";